(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2358],{

/***/ 62019:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[page]",
      function () {
        return __webpack_require__(84280);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layout_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16559);
/* harmony import */ var _lib_syte__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68320);
/* harmony import */ var _store_slices_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40034);
/* harmony import */ var _store_slices_page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53120);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);







var Page = function() {
    var ref;
    var pageState = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_store_slices_page__WEBPACK_IMPORTED_MODULE_3__/* .selectPage */ .Zp);
    var authState = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_store_slices_auth__WEBPACK_IMPORTED_MODULE_2__/* .selectAuth */ .Hz);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!authState.isUserLoading) {
            var ref;
            (0,_lib_syte__WEBPACK_IMPORTED_MODULE_6__/* .syteTrackEvent */ .l)({
                name: "fe_page_view",
                tag: "ecommerce",
                osh_id: (ref = authState.user) === null || ref === void 0 ? void 0 : ref.uuid
            });
        }
    }, [
        authState.isUserLoading,
        (ref = authState.user) === null || ref === void 0 ? void 0 : ref.uuid
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: !!pageState.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: pageState.data.content
                }
            })
        })
    });
};
Page.getLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(62019); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);